import {
  CarouselButton as DsCarouselButton,
  type CarouselButtonProps
} from '@carvana/ds-button';
import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const SlideWrapper = createComponent('div', {
  className: 'flex flex-col items-center justify-end px-lg'
});

export const SlideContentWrapper = createComponent('div', {
  className: cx(
    'pointer-events-none flex flex-col justify-end gap-y-2xl md:relative md:col-span-full md:row-span-full',
    'w-full px-xl pb-2xl text-text-inverse sm:-mt-4xl sm:px-2xl md:mt-0 md:max-w-[733px]',
    'user-select-none duration-[400ms] sm:transition-opacity'
  )
});

export const ButtonsOuterWrapper = createComponent('div', {
  className:
    'pointer-events-none absolute inset-0 hidden px-3xl sm:block lg:px-4xl'
});

export const ButtonsInnerWrapper = createComponent('div', {
  className:
    'mx-auto flex h-full w-full max-w-[1272px] items-center justify-between'
});

export const CarouselButton = createComponent<CarouselButtonProps>(
  DsCarouselButton,
  _ => ({
    className:
      'pointer-events-auto h-56 w-56 min-h-24 min-w-24 border-0 shadow-md'
  })
);

export const INACTIVE_SLIDE_OPACITY = 0.15;
